import React, { useEffect } from 'react'
import {
    CloseSquareOutlined,
  } from "@ant-design/icons";
  import { Divider, Space, Tag } from 'antd';

const CustomTags = ({tagText , backgroundColor, icon}) => {
    const tagStyle = {
        width: "100%", // Width customization
        height: "35.22px", // Height customization
        fontSize: 14, // Font size customization
        display: "flex",
        justifyContent: "center", // Centering horizontally
        alignItems: "center", // Centering vertically
        backgroundColor: backgroundColor, // Background color customization
        zIndex: 1, // z-index customization
        // margin: '10px', // Margin customization
        padding: "5px", // Padding customization
        color: "#FFFFFF",
        borderRadius: "7px",
        gap: "10px",
        padding: '8px 18px 8px 18px'
      };

      useEffect (() => {
        console.log("tag text: ",tagText)
        console.log("background color through props: ",backgroundColor)
      }) 
    
  return (
    <div>
      <Tag style={tagStyle}>
        {icon}
        <p style={{fontSize:'14px'}}>{tagText}</p>
      </Tag>
    </div>
  )
}

export default CustomTags
